import { Typography } from 'antd';
import CopyIcon from '../Icons/CopyIcon';

const { Paragraph } = Typography;

type CopyToClipboardProps = {
  text: string;
  hideText?: boolean
};
export const CopyToClipboard = ({ text, hideText }: CopyToClipboardProps) => {
  return (
    <>
      <Paragraph
        copyable={{
          icon: [<CopyIcon key="copy-icon" />],
          tooltips: ['Sao chép', 'Đã sao chép!!'],
          text: text
        }}
      >
        {!hideText && text}
      </Paragraph>
    </>
  );
};
